import React, { useEffect, useState } from "react";
import {
  Box,
  createStyles,
  Flex,
  Button,
  Text,
} from "@mantine/core";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useSelector } from "react-redux";
import {
  getPendingActions,
  getStaffDashboardCounts,
} from "../../../services/dashboard";
import { getAllStaff } from "../../../services/staff";
import { getAllNoteTypes } from "../../../services/note";
import {
  getAllFacilitiesModal,
  getAllFacilityTypes,
  getBillingCache,
} from "../../../services";
import { getAllPatientsModal } from "../../../services/patient";
import { TrackPageView } from "../../../config/mixpanelConfig";
import ComplianceTabs from "./ComplianceTabs";
import PendingAction from "./PendingAction";
import StaffGreetings from "../../../components/StaffGreetings";
import DashboardTimer from "../../../components/DashboardTimer";
import moment from "moment";
import { useDisclosure } from "@mantine/hooks";
import BlueInfoSvg from "../../../components/Svgs/BlueInfoSvg";
import { RxCross1 } from "react-icons/rx";
import {
  getNotifications,
} from "../../../services/notification";
import AttendanceModal from "../../../containers/StaffModal/AttendanceModal";
import { getAllAttendenceStaff } from "../../../services/staff";
import UploadStaffDocDashboard from "../../../components/StaffDetails/UploadStaffDocDashboard";
import { TbClockHour1 } from "react-icons/tb";
import { getAllSignatures } from "../../../services/signature";
const useStyles = createStyles(() => ({
  dashboard: {
    width: "100%",
    backgroundColor: "var(--app-bg)",
  },
  clockInText: {
    borderRadius: "8px",
    border: "1px solid  #E4E4E7",
    background: "var(--app-surface)",
    padding: "12px",
    margin: "15px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "5px",
  },
  workLogBtn: {
    margin: "0 1rem 0 .5rem",
    borderRadius: "7px",
    background: "var(--app-surface)",
    color: "var(--app-text)",
    outline: "1px solid var(--app-border)",
  },
}));
const NewDashboard = ({ isSidebarOpen }) => {
  const { classes } = useStyles();
  const { selectedDocModal } = useSelector((state) => state?.document);
  const { profile } = useSelector((state) => state?.profile);
  const { allFacilities } = useSelector((state) => state?.facility);
  const { allPatients } = useSelector((state) => state?.patient);
  const [mode, setmode] = useState("view");
  const [dateRange] = useState({
    type: null,
    date: [
      moment().subtract(1, "month").startOf("day").toDate(),
      moment().endOf("day").toDate(),
    ],
  });
  const [range, setRange] = useState([
    moment(dateRange?.date?.[0]),
    moment(dateRange?.date?.[1]),
  ]);
  const [refresh, setRefresh] = useState(false);
  const [isStaffModalOpen, { open: openStaffModal, close: closeStaffModal }] =
    useDisclosure(false);

  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [userTracking, setUserTracking] = useState(null);
  const [showInfo, setShowInfo] = useState(null);
  const [showClockIn, setShowClockIn] = useState(false);

  useEffect(() => {
    getStaffDashboardCounts(dateRange);
    getAllSignatures();
    getNotifications({ page: 1, perPage: 10, client: "" });
  }, []);

  useEffect(() => {
    let newDate = new Date();
    let newDateString = newDate.toISOString().slice(0, 10);
    localStorage.setItem("calendar_date", `daily_${newDateString}`);

    getPendingActions();
    getAllStaff("all");
    getAllNoteTypes();
    getAllFacilityTypes();
    getAllFacilitiesModal();
    getAllPatientsModal();
    getBillingCache();

    TrackPageView("Dashboard");
  }, []);

  const attendenceStaff = async () => {
    try {
      await getAllAttendenceStaff(1, range);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    attendenceStaff();
  }, [range]);

  return (
    <Box className={classes.dashboard}>
      <AppNavbar
        title={profile?.user?.role === "staff" ? "Dashboard" : "Command Center"}
        profile={profile}
        isSidebarOpen={isSidebarOpen}
        titleExtra={
          (!profile?.user?.type || profile?.user?.role === "admin") ? (
            <Flex align="center" gap={10}>
              <span
                id="cc-learn-more-trigger"
                style={{
                  fontFamily: "Inter",
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "var(--app-primary)",
                  cursor: "pointer",
                  textDecoration: "none",
                }}
                onMouseEnter={(e) => { e.target.style.textDecoration = "underline"; e.target.style.color = "#FF6B35"; }}
                onMouseLeave={(e) => { e.target.style.textDecoration = "none"; e.target.style.color = "var(--app-primary)"; }}
                onClick={() => {
                  // Dispatch custom event to open Learn More modal inside ComplianceTabs
                  window.dispatchEvent(new CustomEvent("openCommandCenterLearnMore"));
                }}
              >Learn More</span>
            </Flex>
          ) : null
        }
      />
      <Box pl={6}>
        {profile?.user?.type === "staff" && (
          <>
            <StaffGreetings
              userName={profile?.user?.name ? profile?.user?.name : "staff"}
              text=""
            />
          </>
        )}
        {/* Work Log + Clock-in buttons are inside ComplianceTabs tab bar for admins */}
        {profile?.user?.type === "staff" && (
          <Flex align={"center"} justify="flex-end" mt={20} mr={20} gap={5}>
            <img src={"/assets/images/ghari.png"} alt="" width={25} height={25} />
            <Button
              onClick={() => openStaffModal("view")}
              className={classes.workLogBtn}
              variant="outline"
            >
              Work Log
            </Button>
          </Flex>
        )}
        {/* Staff Clock-in/out  */}
        {(showClockIn || profile?.user?.type === "staff") && (
          <DashboardTimer
            startTime={startTime}
            setStartTime={setStartTime}
            endTime={endTime}
            setEndTime={setEndTime}
            userTracking={userTracking}
            setUserTracking={setUserTracking}
            setShowInfo={setShowInfo}
            setShowClockIn={setShowClockIn}
          />
        )}
        {showInfo && userTracking && (
          <Box className={classes.clockInText}>
            {" "}
            <Flex align={"center"} gap={1}>
              <BlueInfoSvg />
              {userTracking?.client
                ? <>
                    You’ve clocked in to{" "}
                    {allPatients?.find((p) => p?.id === userTracking?.client)?.name || ""}’s
                    current location at{" "}
                  </>
                : <>
                    You’ve clocked in at{" "}
                    {(profile?.user?.type === "staff"
                      ? profile?.user?.facilityId?.find(
                          (f) => f?.id === userTracking?.facility
                        )?.name
                      : allFacilities?.facilities?.find(
                          (f) => f?.id === userTracking?.facility
                        )?.name) || ""}{" "}
                    at{" "}
                  </>
              }
              {startTime
                ? moment(userTracking?.startTime).format("hh:mm A")
                : ""}
            </Flex>
            <Box
              onClick={() => setShowInfo(false)}
              style={{ cursor: "pointer" }}
            >
              <RxCross1 />
            </Box>
          </Box>
        )}
        {/* SkAi is now the floating widget (mounted in Home shell) — inline card removed */}
        {/* Compliance Manager: only for admins and staff with admin role */}
        {/* Regular staff see only their pending actions / tasks */}
        {(!profile?.user?.type || profile?.user?.role === "admin") ? (
          <Box px={10} mt={10}>
            <ComplianceTabs
              onOpenWorkLog={() => { setmode("edit"); openStaffModal(); }}
              onOpenClockIn={() => setShowClockIn(true)}
            />
          </Box>
        ) : (
          <Box px={10} mt={10}>
            <PendingAction />
          </Box>
        )}
      </Box>
      <AttendanceModal
        mode={mode}
        range={range}
        setRange={setRange}
        refresh={refresh}
        setRefresh={setRefresh}
        title="Work Logs"
        opened={isStaffModalOpen}
        onclose={closeStaffModal}
        selectedItem={profile?.user?.id}
      />
      {selectedDocModal && (
        <UploadStaffDocDashboard
          selectedFolder={selectedDocModal?.folder}
          userId={selectedDocModal?.userId}
          isPendingAction={true}
          uploadedFiles={selectedDocModal}
        />
      )}
    </Box>
  );
};

export default NewDashboard;
